import React from 'react'

export const emptyCharacter = '-'

export const EmptyChar = () => <span>{emptyCharacter}</span>
